import api from "../..";
import type { DeleteVideoParams } from "./types";

export const deleteVideo = async ({ uuid }: DeleteVideoParams): Promise<boolean> => {

  return await api.delete(`/admin/video/${uuid}/`)
  .then(() => true)
  .catch(() => false);
};
